import { render, staticRenderFns } from "./purchaseTabs.vue?vue&type=template&id=f68d5fe4&scoped=true&"
import script from "./purchaseTabs.vue?vue&type=script&lang=js&"
export * from "./purchaseTabs.vue?vue&type=script&lang=js&"
import style0 from "./purchaseTabs.vue?vue&type=style&index=0&id=f68d5fe4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68d5fe4",
  null
  
)

export default component.exports